import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChartBar, FileText } from '@phosphor-icons/react';
import {
  REPORTS_PERFORM_SPARK_ROUTE,
  REPORTS_PERFORM_SPARK_ROUTES,
  REPORTS_CUSTOM_ROUTE,
  REPORTS_CUSTOM_ROUTES,
} from '../../constants/reports-routes';

interface ReportsTabsProps {
  rightSlot?: React.ReactNode;
}

export const ReportsTabs: React.FC<ReportsTabsProps> = ({ rightSlot }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const normalizePath = (path: string) =>
    path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path;
  const currentPath = normalizePath(location.pathname);

  // Tab configuration - easily extensible for future tabs
  const tabs = [
    {
      id: 'performance-management',
      label: 'Library',
      icon: ChartBar,
      to: REPORTS_PERFORM_SPARK_ROUTE,
      matchers: REPORTS_PERFORM_SPARK_ROUTES,
    },
    {
      id: 'report-configuration',
      label: 'Configure',
      icon: FileText,
      to: REPORTS_CUSTOM_ROUTE,
      matchers: REPORTS_CUSTOM_ROUTES,
    },
  ] as const;

  return (
    <div>
      {/* Tabs + optional right slot */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[18px] overflow-x-auto">
        {tabs.map((tab) => {
          const isActive = tab.matchers.some(
            (matcher) => {
              const normalizedMatcher = normalizePath(matcher);
              return currentPath === normalizedMatcher || currentPath.startsWith(`${normalizedMatcher}/`);
            }
          );
          const IconComponent = tab.icon;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => navigate(tab.to)}
              className={`flex items-center gap-2 pb-1 hover:opacity-80 transition-opacity whitespace-nowrap ${isActive ? 'border-b-2 border-primary' : ''
                }`}
            >
              <IconComponent
                className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-primary' : 'text-gray-500'
                  }`}
                weight={isActive ? 'fill' : 'regular'}
              />
              <span
                className={`text-sm ${isActive
                  ? 'text-primary font-medium'
                  : 'text-gray-600 hover:text-primary'
                  }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
        </div>
        {rightSlot && <div className="flex-shrink-0">{rightSlot}</div>}
      </div>
    </div>
  );
};
